import script from "./area_page.vue?vue&type=script&setup=true&lang=js"
export * from "./area_page.vue?vue&type=script&setup=true&lang=js"

import "./area_page.vue?vue&type=style&index=0&id=7fc9bb44&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc9bb44"]])

export default __exports__